import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Countries from 'assets/countries.json'
import InputAdornment from "@material-ui/core/InputAdornment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ReactSelect from 'components/Select/ReactSelect';
import AccountBalance from '@material-ui/icons/AccountBalance';
import CardTravel from '@material-ui/icons/CardTravel';
import Api from '../../../../api/Api.js';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';

// import Api from '../../../../api/Api.js';
// import CustomerEndpoints from '../../../../api/CustomerEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class EditCustomerDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            nameState: "",
            registration_no: props.registration_no || "",
            registration_noState: "",
            vat_no: props.vat_no || "",
            vat_noState: "",
            country: props.country ? { label: Countries.find(x => x.code == props.country).name, value: props.country } : { label: "South Africa", value: "ZA" },
            countryState: "",
            company: props.company,
            companyState: "",
            loading: false
        }

        this.countryMenuItems = Countries.map(x => ({ label: x.name, value: x.code }));
    }

    countryMenuItems = [];
    sendState() {
        return this.state;
    }
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }
    change(event, name, type = "required") {
        switch (type) {
            case "required":
                if (event.target.value) {
                    this.setState({ [name + "State"]: "success" });
                } else {
                    this.setState({ [name + "State"]: "error" });
                }
                break;
            default:
                break;
        }
        this.setState({ [name]: event.target.value });
    }
    
    submit() {
        this.setState({ loading: true }, () =>
            Api.post(CustomerEndpoints.edit, { ...this.state, country: this.state.country.value, account_no: 'EDIT', id: this.props.customer_id })
                .then(() => {
                    this.props.close();
                    this.props.refresh({ ...this.state, country: this.state.country.value });
                    this.setState({ loading: false })
                })
                .catch((e) => this.setState({ loading: false }, () => console.error(e)))
        );
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Edit Customer</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <GridContainer justify="center">
                        <GridItem xs={12}>
                            <CustomInput
                                success={this.state.nameState === "success"}
                                error={this.state.nameState === "error"}
                                labelText={
                                    <span>
                                        Customer Name <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.change(event, "name"),
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <CardTravel className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    ),
                                    value: this.state.name,
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInput
                                success={this.state.registration_noState === "success"}
                                error={this.state.registration_noState === "error"}
                                labelText={
                                    <span>
                                        Registration Number
                                    </span>
                                }
                                id="registration_no"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.change(event, "registration_no", "optional"),
                                    value: this.state.registration_no,
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <AccountBalance className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInput
                                success={this.state.vat_noState === "success"}
                                error={this.state.vat_noState === "error"}
                                labelText={
                                    <span>
                                        VAT Number
                                    </span>
                                }
                                id="vat_no"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.change(event, "vat_no", "optional"),
                                    value: this.state.vat_no,
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.inputAdornment}
                                        >
                                            <AccountBalance className={classes.inputAdornmentIcon} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <ReactSelect
                                label="Country"
                                options={this.countryMenuItems}
                                value={this.state.country}
                                onChange={(value) => this.setState({ country: value })}
                                isSearchable
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="company"
                                    className={classes.selectLabel}
                                    shrink
                                >
                                    Company / Legal Entity
                                </InputLabel>
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={this.state.company}
                                    onChange={(event) => this.change(event, "company")}
                                    inputProps={{
                                        name: "company",
                                        id: "company"
                                    }}
                                    color="rose"
                                >
                                    <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose Company</MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Cellfind">
                                        Cellfind
                                    </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Panacea">
                                        Panacea
                                    </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Simigenix">
                                        Simigenix
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>

                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Save Changes
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(EditCustomerDialog);